import React from 'react';
import './RfidReader.css';
import FMSimage from '../Assets/rrrr.jpg'; // First image (full size)
import FMSimage2 from '../Assets/reader2.jpg'; // Image for Key Features & Benefits
import FMSimage3 from '../Assets/reader4.jpg'; // Image for How it Works section
import FMSimage4 from '../Assets/reader4.jpg'; // Image for Why Choose section
import FMSimage5 from '../Assets/rfid5.jpg'; // Image for Industries section

const Rfid = () => {
    return (
        <div className="FMS-container">
            {/* First Section: Layout for Text and Image */}
            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <h1 className="FMS-heading">2.4GHz Active RFID Reader & Tags</h1>
                    <p className="FMS-description">
                        Vajra IoT's 2.4GHz Active RFID Reader and Tags provide a robust solution for real-time tracking and management across diverse applications. Equipped with an external omni-directional antenna, this system ensures long-range, reliable signal transmission for vehicle access control, toll collection, healthcare, asset tracking, manufacturing, personnel tracking, and building security.
                    </p>
                </div>

                {/* Right side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage} alt="2.4GHz Active RFID Reader & Tags" className="FMS-image full-size" />
                </div>
            </div>

            {/* Centered Heading Between Images */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Key Features & Benefits</h2>
            </div>

            {/* Second Section: New Layout for Text and Image */}
            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        Our 2.4GHz Active RFID Reader and Tags offer advanced capabilities for efficient tracking and management:
                        <ul>
                            <li><strong>2.4GHz Frequency:</strong> Enables long-range, high-speed signal transmission for reliable communication.</li>
                            <li><strong>Omni-Directional Antenna:</strong> Provides wide coverage for seamless tracking in diverse environments.</li>
                            <li><strong>Tamper-Proof Design:</strong> Detects unauthorized removal of tags, ensuring asset security.</li>
                            <li><strong>Battery Voltage Monitoring:</strong> Tracks battery levels for timely replacement, minimizing downtime.</li>
                            <li><strong>Versatile Applications:</strong> Supports vehicle access, toll collection, asset tracking, and more with secure data transmission.</li>
                        </ul>
                    </p>
                </div>

                {/* Right side: New Image for Key Features */}
                <div className="FMS-image-container">
                    <img src={FMSimage2} alt="Key Features" className="FMS-image smaller-size" />
                </div>
            </div>

            {/* Centered Heading for How it Works */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">How it Works</h2>
            </div>

            {/* Third Section: Layout for How it Works */}
            <div className="FMS-content-container">
                {/* Left side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage3} alt="How It Works" className="FMS-image smaller-size" />
                </div>

                {/* Right side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        The 2.4GHz Active RFID system operates with precision and efficiency:
                        <ul>
                            <li><strong>Signal Transmission:</strong> Active tags broadcast data at 2.4GHz to the reader via an omni-directional antenna.</li>
                            <li><strong>Real-Time Tracking:</strong> Provides continuous updates on asset, vehicle, or personnel location and status.</li>
                            <li><strong>Tamper Detection:</strong> Alerts are triggered if tags are removed or tampered with, enhancing security.</li>
                            <li><strong>Battery Monitoring:</strong> Reports battery voltage levels to ensure uninterrupted operation.</li>
                            <li><strong>Centralized Dashboard:</strong> Data is processed and visualized on an intuitive platform for easy monitoring and management.</li>
                        </ul>
                    </p>
                </div>
            </div>

            {/* New Section: Why Choose Us */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Why Choose Our 2.4GHz Active RFID System</h2>
            </div>

            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        Our 2.4GHz Active RFID Reader and Tags deliver unmatched performance and flexibility:
                        <ul>
                            <li>Long-range tracking with omni-directional antenna coverage</li>
                            <li>Enhanced security with tamper-proof detection</li>
                            <li>Reliable operation with proactive battery management</li>
                            <li>Seamless integration with vehicle, asset, and personnel tracking systems</li>
                            <li>Real-time analytics for optimized operations</li>
                        </ul>
                    </p>
                </div>

                {/* Right side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage4} alt="Why Choose Us" className="FMS-image smaller-size" />
                </div>
            </div>

            {/* New Section: Industries Using Our System */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Industries Using Our 2.4GHz Active RFID System</h2>
            </div>

            <div className="FMS-content-container reverse-order-last">
                {/* Left side: Image for Industries */}
                <div className="FMS-image-container">
                    <img src={FMSimage5} alt="Industries Using 2.4GHz Active RFID System" className="FMS-image smaller-size" />
                </div>

                {/* Right side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        Our 2.4GHz Active RFID System is trusted across multiple sectors for its versatility and reliability:
                        <ul>
                            <li>Vehicle Access Control & Toll Collection</li>
                            <li>Healthcare</li>
                            <li>Asset Tracking</li>
                            <li>Warehouse Management</li>
                            <li>Logistics</li>
                            <li>Student Management</li>
                            <li>Manufacturing</li>
                            <li>Building Security & Access Control</li>
                        </ul>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Rfid;